<template>
    <!-- add class hidden on launch for the convert testing -->
    <div ref="smTest" id="sm-test" :class="{ 'hidden': !smActive, 'show': smActive }">
        <div :class="{ 'hidden': !areFieldsSet, 'show': areFieldsSet }">
            <div id="sm-component"></div> 
        </div>
    </div>
</template>

<script>
import axios from "axios";
import * as Sentry from "@sentry/browser";
export default {
    mounted() {
        window.smReference = document.getElementById('sm-id').value;
        //data layer object
        window.dataLayer = window.dataLayer || [];
        let variantToken = this.generateVariant();
        var data = {
            "token": variantToken,
            "renderId": "sm-component",
            "autoHideFilledFields": true,
            "autoHideInjectableFormAfterProcessComplete": 5, 
            "extraField": {
                "refTransactionId": window.smReference,
                "customerId": window.smReference,
                "authToken": "DP-b7c03de9-ba11-48e3-bc3c-04ac3dd99d88",
                "authPassword": "DP-77d901e0-dc3f-4ef6-ad42-898f56a91ba9",
                "cid": '530037',
                "campid": '706',
                "dp": '',
                "dpid": '',
                "brandId": '48e814b0-ef06-4c5a-9248-02e70941ef27',
                "regionId": 'b4bf6a9d-3b31-470f-8761-523b4bdf4d62',
                "promotion_id": 'a04d0101-2323-4dfd-b7bb-454e623bc1cb',
            },
            "defaultFields": {
                "if-first_name": "#forename",
                "if-surname": "#surname",
                "if-email": "#email",
                "if-phone": "#mobile",
                "if-birth_date": "#dob",
                "if-home_address_postcode": "#postcode",
                "if-home_address_house": "#house_number",
                "if-home_address_street": "#street",
                "if-home_address_town": "#town",
                "if-home_address_county": "#county",
            }
        };
        // It will execute this event when Injectable form will initialized.
        // window.ukInjectableExtSDK.on("injectable-form-init", () => {
        //     axios
        //         .post("/sm-progression", {
        //             reference: window.smReference,
        //             email: this.smEmail,
        //             site: "Little Loans",
        //             stage: "Clicked SM Button",
        //         })
        //         .catch(() => {
        //             Sentry.captureMessage("Error saving sm progression " + "Clicked SM Button");
        //         });
        // });

        // It will execute this event when Injectable form modal will open.
        window.ukInjectableExtSDK.on("injectable-form-modal-open", () => {
            window.amplitude.scoresMatterProgress('SM Modal Opened');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Modal Opened",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Modal Opened");
                });
        });

        // It will execute this event when customer will fill the form & submit & validation succeeded.
        window.ukInjectableExtSDK.on("injectable-form-submitted", () => {
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "Valid SM Field Validation",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "Valid SM Form Submission");
                });
        });

        // It will execute this event when customer will fill the form & submit and front-end validation is failed.
        // eg. First name field is required.
        window.ukInjectableExtSDK.on("injectable-form-validation-failed", () => {
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Form Validation Failed",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Form Validation Failed");
                });
        });

        // It will execute this event when customer will fill the form & submit & validation succeeded,
        // we processed the customer data but customer is ineligible for our offer / product.
        window.ukInjectableExtSDK.on("injectable-form-decline", () => {
            window.amplitude.scoresMatterProgress('SM Declined Customer');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Declined Customer",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Declined Customer");
                }).finally(() => {
                    this.$refs.smTest.classList.add('hidden');
                });
        });

        // It will execute this event when customer will fill the form & submit & validation succeeded,
        // we processed the customer data and customer has been successfully converted / succeeded in our product. ( aka conversion + sale )
        window.ukInjectableExtSDK.on("injectable-form-success", () => {
            window.amplitude.scoresMatterProgress('SM Accepted Customer');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Accepted Customer",
                })
                .then(() => {
                    window.dataLayer.push({
                        event: "app",
                        appStatus: "accepted",
                        appCommission: 14.0,
                        appId: window.smReference,
                        email: this.smEmail,
                        formType: "scores-matter-modal-form",
                    });
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Accepted Customer");
                }).finally(() => {
                    this.$refs.smTest.classList.add('hidden');
                });
        });

        // It will execute this event when customer will fill the form & submit & validation succeeded,
        // we processed the customer data and we figure out that customer is already existing customer of our product.
        window.ukInjectableExtSDK.on("injectable-form-customer-already-exists", () => {
            window.amplitude.scoresMatterProgress('SM Customer Already Exists');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Customer Already Exists",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Customer Already Exists");
                }).finally(() => {
                    this.$refs.smTest.classList.add('hidden');
                });
        });

        // It will execute this event when customer will fill the form & submit & validation succeeded,
        // we processed the customer data and we tried to capture payment or 0-auth but using provided card it failed. ( aka bad card, they do not have money in them account etc.. )
        window.ukInjectableExtSDK.on("injectable-form-try-different-card", () => {
            window.amplitude.scoresMatterProgress('SM Credit Card Error');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Customer Credit Card Error",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Customer Credit Card Error");
                });
        });

        // It will execute this event when Injectable form modal will close.
        window.ukInjectableExtSDK.on("injectable-form-modal-close", () => {
            window.amplitude.scoresMatterProgress('SM Form Modal Closed');
            axios
                .post("/sm-progression", {
                    reference: window.smReference,
                    email: this.smEmail,
                    site: "Little Loans",
                    stage: "SM Form Modal Closed",
                })
                .catch(() => {
                    Sentry.captureMessage("Error saving sm progression " + "SM Form Modal Closed");
                })
        });

        window.ukInjectableExtSDK.init(data);
    },
    computed: {
        areFieldsSet() {
            // Check if the core default fields are set
            return (
                !!this.customer.address?.postcode &&
                !!this.customer.forename &&
                !!this.customer.surname &&
                !!this.customer.email &&
                !!this.customer.mobile);
        },
        smEmail() {
            return document.getElementById('email').value;
        },
        smActive() {
            // Set to always be true as of 18/3/2024
            return true;
            // // Get the query string from the current URL
            // const queryString = window.location.search;

            // // Parse the query string using URLSearchParams
            // const params = new URLSearchParams(queryString);

            // // Check if the 'sm' parameter is present and equals '1'
            // if (params.has('sm') && params.get('sm') === '1') {
            //     return true;
            // } else {
            //     return false;
            // }
        },
    },
    props: {
        name: {
            default: ""
        },
        customer: Object,
    },
    methods: {
        generateVariant() {
            let variant = Math.floor(Math.random() * 4);
            switch(variant) {
                // V1
                case 1:
                    return "6613d4907923590e2593db00"
                // V2
                case 2:
                    return "6613d778e041350e058f7f13"
                // V3
                case 3:
                    return "6613d8db4a25b30e304f22a6"   
                //current version
                default:
                    return "65e1b9181e15ef0dd5274927"
            }   
        },
    },
};
</script>
<style lang="scss">
</style>
